import app from "../app";

app.value('buildings', [
    {
      id: 0,
      name: "Tent",
      count: 0,
      enabled: true,
      tier: 1,
      baseCost : 5,
      cost: 5,
      multiplier: 4,
      description: "This building allows heroes to join the town.",
    },
    {
      id: 1,
      name: "Stockpile",
      count: 0,
      enabled: false,
      tier: 1, 
      baseCost : 25,
      cost: 25,
      multiplier: 25,
      description:
        "Adds the Ability to create potions to sell to heroes for gold as well as extending the gold and resource capacities.",
    },
    {
      id: 2,
      name: "Market",
      count: 0,
      enabled: false,
      tier: 1,  
      baseCost : 40,
      cost: 40,
      multiplier: 1.07,
      description:
        "Allows you to purchase blueprints which unlock new buildings.",
    },
    {
      id: 3,
      name: "Blacksmith",
      count: 0,
      enabled: false,
      tier: 1,
      baseCost : 100,
      cost: 100,
      multiplier: 1.07,
      description:
        "Allows you to construct weapons which can be sold to the hero for gold.",
    },
    {
      id: 4,
      name: "Tavern",
      count: 0,
      tier: 1,
      baseCost : 150,
      cost: 150,
      multiplier: 1.07,
      description:
        "Allows you to purchase Upgrades giving small bonuses to many different things.",
    },
    {
      id: 5,
      name: "Alchemist",
      count: 0,
      tier: 1,
      baseCost : 1000,
      cost: 1000,
      multiplier: 1.07,
      description:
        "Allows you to construct better potions that provide benefits to the hero.",
    },
    {
      id: 6,
      name: "Dungeons",
      count: 1,
      enabled: false,
      tier: 1,
      baseCost : 25,
      cost: 25,
      multiplier: 1.07,
      description: "Discovers a new Dungeon for your heroes",
    },
    {
      id: 7,
      name: "Academy",
      count: 0,
      enabled: false,
      tier: 1,
      baseCost : 10000,
      cost: 10000,
      multiplier: 1.07,
      description: "Allows heroes to gain a class",
    },
    {
      id: 8,
      name: "Elite Dungeons",
      count: 0,
      enabled: false,
      tier: 1,
      baseCost : 35000,
      cost: 35000,
      multiplier: 1.07,
      description: "Allows parties to adventure into elite dungeons.",
    },
    {
      id: 9,
      name: "Work Hut",
      count: 0,
      enabled: false,
      teir: 1,
      baseCost : 100,
      cost: 100,
      multiplier: 1.07,
      description: "Allows you to train workers and gatherers.",
    },
  ]);